import React from "react";
import { Skeleton as AntSkeleton } from "antd";
import { SkeletonProps as AntSkeletonProps } from "antd/lib/skeleton";

export const Skeleton = (props: AntSkeletonProps) => {
  const { children, ...rest } = props;
  return <AntSkeleton {...rest}>{children}</AntSkeleton>;
};
